export default function () {
    gsap.defaults({ease: "none", duration: 1})

    const gsapMatchMedia = gsap.matchMedia();

    const scrollConfig = {
        scrollTrigger: {
            trigger: ".parallax-cols",
            start: "top 50%",
            end: "+=600",
            scrub: 1,
            pin: false,
        }
    };

    // Schermi LG e superiori
    gsapMatchMedia.add("(min-width: 992px)", () => {
        let tl = gsap.timeline(scrollConfig)
            .fromTo(".parallax-cols__figure-1",
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .fromTo(".parallax-cols__figure-2",
                {y: 0, clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {y: -150, clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .fromTo(".parallax-cols__figure-3",
                {y: 0, clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {y: -100, clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .to(
                ".parallax-cols__figure-1 img, .parallax-cols__figure-2 img, .parallax-cols__figure-3 img",
                {scale: 1.3, duration: 0.5}, "0.7"
            );

        return () => tl.kill(); // cleanup al resize
    });

    // Mobile / tablet
    gsapMatchMedia.add("(max-width: 991px)", () => {
        let tl = gsap.timeline(scrollConfig)
            .fromTo(".parallax-cols__figure-1",
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .fromTo(".parallax-cols__figure-2",
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .fromTo(".parallax-cols__figure-3",
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"},
                {clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"}, 0)
            .to(
                ".parallax-cols__figure-1 img, .parallax-cols__figure-2 img, .parallax-cols__figure-3 img",
                {scale: 1.3, duration: 0.5}, "0.7"
            );

        return () => tl.kill();
    });
}